import { useEffect, useState } from "react";
import axios from "axios";
import liff from "@line/liff";
import LoadingScreen from "../Loading/LoadingScreen";
import { CURRENT_ENV } from "../../Utills/constants";

function LuckySlotMachine11() {
  const [profileLine, setProfileLine] = useState();
  const [listRewards, setListRewards] = useState(null);
  const [data, setData] = useState(null);
  const [isSpinning, setIsSpinning] = useState(false);
  const [result, setResult] = useState(null);
  const [loading, setLoading] = useState(true);

  const [reel1, setReel1] = useState(null);
  const [reel2, setReel2] = useState(null);
  const [reel3, setReel3] = useState(null);


  useEffect(() => {
    liff
      .init({
        liffId: CURRENT_ENV.LIFF_ID11,
      })
      .then(async () => {
        if (liff.isLoggedIn()) {
          liff
            .getProfile()
            .then((profile) => {
              setProfileLine(profile.userId);
            })
            .catch((err) => {
              console.log("%cERROR LINEOA DETAIL", "color: red", err);
            });
        } else {
          liff.login();
        }
      })
      .catch((err) => {
        console.log(
          "%cERROR LINEOA HEADER",
          "color: red",
          err.code,
          err.message
        );
      });
    return () => { };
  }, []);

  useEffect(() => {
    const fetchAllData = async () => {
      if (!profileLine) {
        setLoading(false);
        return;
      }

      setLoading(true);

      try {
        const [rewardsRes, userRes] = await Promise.all([
          axios.get(`${CURRENT_ENV.API_BASE_URL11}?path=getRewards`),
          axios.get(`${CURRENT_ENV.API_BASE_URL11}?path=getData&userId=${profileLine}`)
        ]);

        if (rewardsRes.data.status === 200) {
          setListRewards(rewardsRes.data.data);
        }

        if (userRes.data.status === 200) {
          setData(userRes.data.data);
        }

      } catch (err) {
        console.error("เกิดข้อผิดพลาดในการดึงข้อมูล:", err);
      } finally {
        setLoading(false);
      }
    };

    fetchAllData();
  }, [profileLine]);

  const getRandomReward = (rewards) => {
    const total = rewards.reduce((sum, item) => sum + item.percent, 0);
    let random = Math.random() * total;
    let cumulative = 0;
    for (let i = 0; i < rewards.length; i++) {
      cumulative += rewards[i].percent;
      if (random <= cumulative) return rewards[i];
    }
    return rewards[rewards.length - 1];
  };

  const spinSlot = async () => {
    if (isSpinning || !listRewards || (data && data.value >= data.total)) return;

    setIsSpinning(true);
    setResult(null);

    const spinInterval = setInterval(() => {
      const randomItem1 = listRewards[Math.floor(Math.random() * listRewards.length)];
      const randomItem2 = listRewards[Math.floor(Math.random() * listRewards.length)];
      const randomItem3 = listRewards[Math.floor(Math.random() * listRewards.length)];

      setReel1(randomItem1);
      setReel2(randomItem2);
      setReel3(randomItem3);
    }, 80);

    setTimeout(async () => {
      clearInterval(spinInterval);

      const wonReward = getRandomReward(listRewards);

      setReel1(wonReward);
      setReel2(wonReward);
      setReel3(wonReward);

      setResult(wonReward);

      try {
        setLoading(true)

        const response = await axios.get(`${CURRENT_ENV.API_BASE_URL11}?path=play2&userId=${profileLine}&reward=${wonReward.name}`);

        if (response.data?.status === 200) {
          liff
            .sendMessages([
              {
                "type": "flex",
                "altText": `ยินดีด้วยคุณได้รับรางวัล คลิกเพื่อดู`,
                "contents": {
                  "type": "bubble",
                  "hero": {
                    "type": "image",
                    "url": CURRENT_ENV.FLEX_IMAGE11,
                    "size": "full",
                    "aspectRatio": "20:13",
                    "aspectMode": "cover"
                  },
                  "body": {
                    "type": "box",
                    "layout": "vertical",
                    "contents": [
                      {
                        "type": "text",
                        "text": "แทนคำขอบคุณในเดือนมีนาคม",
                        "weight": "bold",
                        "size": "xl"
                      },
                      {
                        "type": "box",
                        "layout": "vertical",
                        "contents": [
                          {
                            "type": "text",
                            "text": `ยินดีด้วยคุณได้รับ ${wonReward.name}`,
                            "size": "lg",
                            "color": "#B3B3B3",
                            "wrap": true
                          }
                        ]
                      }
                    ]
                  }
                }
              }
            ])
            .then(() => {
              window.alert("ส่งรางวัลไปยังช่องแชทเรียบร้อยค่ะ")
            })
            .catch((err) => {
              console.log("error", err);
            });
        } else if (response.data.status === 204) {
          window.alert(response.data.message)
        }
      } catch (_) { }
      finally {
        setLoading(false)
      }

    }, 2500);
  };

  // Component สำหรับแสดงแต่ละ Reel
  const ReelDisplay = ({ reward }) => {
    if (!reward) {
      return (
        <div style={reelStyle}>
          <span style={{ fontSize: "40px" }}>❓</span>
        </div>
      );
    }

    return (
      <div style={reelStyle}>
        <div style={{
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          justifyContent: "center",
          height: "100%",
          padding: "8px",
          textAlign: "center"
        }}>
          <img
            src={reward.image}
            alt={reward.name}
            style={{
              width: "52px",
              height: "52px",
              objectFit: "contain",
              marginBottom: "6px"
            }}
          />
          <div style={{
            fontSize: "13px",
            fontWeight: "bold",
            lineHeight: "1.2",
            marginBottom: "4px"
          }}>
            {reward.name}
          </div>

        </div>
      </div>
    );
  };

  return (
    <>
      {loading && <LoadingScreen />}

      <div className="container app-bg1" style={{
        textAlign: "center",
        minHeight: "100vh",
      }}>

        <h1 className="txt-title" style={{ fontSize: "28px", margin: "15px 0 5px 0" }}>
          🎰 LUCKY SLOT MACHINE
        </h1>
        <p style={{ fontSize: "18px", marginBottom: "25px", opacity: 0.9, color: "#ffffff" }}>
          หมุนแล้วรับรางวัลตามโอกาส!
        </p>

        {/* === เครื่องสล็อต === */}
        <div style={{
          display: "flex",
          justifyContent: "center",
          gap: "12px",
          margin: "30px auto",
          padding: "25px 20px",
          background: "#1a1a1a",
          border: "10px solid #ffd700",
          borderRadius: "25px",
          maxWidth: "380px",
          boxShadow: "0 15px 35px rgba(0, 0, 0, 0.5)"
        }}>
          <ReelDisplay reward={reel1} />
          <ReelDisplay reward={reel2} />
          <ReelDisplay reward={reel3} />
        </div>

        {/* ปุ่มหมุน */}
        {listRewards && (!data || data.value < data.total) && !isSpinning && (
          <button
            onClick={spinSlot}
            disabled={isSpinning}
            style={{
              margin: "20px 0",
              padding: "16px 55px",
              fontSize: "23px",
              fontWeight: "bold",
              border: "2px solid white",
              borderRadius: "50px",
              background: isSpinning ? "#555" : "linear-gradient(45deg, #ffdd00, #ff8800)",
              color: "#000",
              boxShadow: "0 8px 20px rgba(255, 215, 0, 0.5)",
              cursor: isSpinning ? "not-allowed" : "pointer",
            }}
          >
            {isSpinning ? "กำลังหมุน..." : "🌀 หมุนเลย!"}
          </button>
        )}

        {/* ผลรางวัล */}
        {result && (
          <div style={{
            padding: "10px 60px",
            maxWidth: "340px",
            background: "rgb(255, 255, 255)",
            border: "4px solid #9bff15",
            borderRadius: "20px",
            fontSize: "21px",
            fontWeight: "bold"
          }}>
            🎉 คุณได้รับ <span style={{ color: "#ff0000", fontSize: "23px" }}>{result.name}</span>
          </div>
        )}

        {/* ใช้สิทธิ์ครบ */}
        {data?.value >= data?.total && (
          <div style={{
            margin: "20px auto",
            padding: "18px 25px",
            maxWidth: "340px",
            background: "rgba(255,255,255,0.15)",
            border: "4px solid #ff4444",
            borderRadius: "20px",
            fontSize: "20px",
            fontWeight: "bold", color: "#ffffff"
          }}>
            ❌ คุณใช้สิทธิ์สุ่มรางวัลครบแล้ว!
          </div>
        )}

        {
          listRewards ?
            <div style={{ margin: '20px 0px' }}>
              <div style={{ display: `flex`, justifyContent: `center`, padding: `0px 10px 10px 10px`, overflow: `scroll`, height: 200 }}>
                <div style={{ display: `grid`, width: `100%` }}>
                  <div className="grid-container">
                    {
                      listRewards?.map((data, index) => (
                        <div key={index}>
                          <div style={{ display: `flex`, justifyContent: `center`, alignItems: `center`, flexDirection: `column`, margin: 1, fontSize: 12, padding: `7px 0` }}>
                            <img src={data.image} alt="" style={{ width: 30 }} />
                            <div>
                              {data.name}
                            </div>
                          </div>
                        </div>
                      ))
                    }
                  </div>
                </div>
              </div>
            </div> : null
        }
      </div>
    </>
  );
}

const reelStyle = {
  width: "95px",
  height: "135px",
  background: "#ffffff",
  color: "#000",
  borderRadius: "12px",
  border: "6px solid #222",
  boxShadow: "inset 0 6px 12px rgba(0, 0, 0, 0.25)",
  overflow: "hidden",
  display: "flex",
  alignItems: "center",
  justifyContent: "center"
};

export default LuckySlotMachine11;